import {Flex, Typography} from 'antd'

const {Text} = Typography

const PermissionPlaceholder = ({minHeight = 200, style = {}}) => {
  return (
    <Flex align="center" justify="center" style={{minHeight, width: '100%', ...style}}>
      <Text type="secondary">{"You don't have permission to view this"}</Text>
    </Flex>
  )
}

export default PermissionPlaceholder
